export default {
  id: 'en',
  languages: {
    en: 'English',
    es: 'Español'
  },
  general: {
    name: 'Exis',
    businesName: 'Exis',
    channel: "SART APP",
  },
  common: {
    loading: "Loading",
    loadingData: "Loading Customer Data...",
    loadingServiceData: "Loading Service Data...",
    change: 'Change',
    choose: 'Choose',
    send: "Send",
    sending: "Sending...",
    continue: 'Continue',
    processing: 'Processing...',
    apply: "Apply",
    submit: "Submit",
    submitting: "Submitting...",
    cancel: "Cancel",
    cancelled: "Cancelled",
    back: "Back",
    reset: "Reset",
    clear: "Clear",
    delete: "Delete",
    remove: "Remove",
    help: 'Need help?',
    save: "Submit",
    confirm: "Confirm",
    infinity: "∞"
  },
  forms: {
    titleLabel: "Title",
    titlePlaceholder: "title",
    sex: "Gender",
    sexTwo: "Sex",
    firstNameLabel: "Forename",
    firstNamePlaceholder: "forename",
    middleNameLabel: "Middle Name",
    middleNamePlaceholder: "middle name",
    lastNameLabel: "Surname",
    lastNamePlaceholder: "surname",
    lastNameOptionTwo: "Surname",
    lastNameOptionTwoPlaceholder: "surname",
    accountHolderLabel: "Account Holder",
    IdTypeLabel: "ID Type",
    IdTypePlaceholder: "Select type of ID",
    idTypePassport: "Passport",
    idTypeIdCard: "ID Card",
    idTypeDriversLicense: "Driver's License",
    idTypeOther: "Other",
    idNumberLabel: "ID Number",
    idNumberPlaceholder: "ID Number",
    idNumberFooter: "This will be verified by an independent company",
    vatLabel: "RFC (In Case You Need Invoice)",
    vatPlaceholder: "RFC",
    vatFooter: "It will be used to generate your receipts",
    dobLabel: "Date of Birth",
    dobPlaceholder: "dd-mm-yyyy",
    dobInvalid: "Please enter a valid DOB (over 18s only)",
    dayLabel: "Day",
    dayPlaceholder: "DD",
    monthLabel: "Month",
    monthPlaceholder: "MM",
    monthInvalid: 'Month Invalid',
    yearLabel: "Year",
    yearPlaceholder: "YYYY",
    yearPlaceHolderTwoDigit: "YY",
    emailLabel: "Email",
    usernameLabel: "Username",
    usernameLabelLowercase: "username",
    emailPlaceholder: "email address",
    emailInvalid: "Please enter a valid email address",
    emailInvalidCharacters: "Please enter a valid email address \nonly lowercase characters and no special characters",
    passwordLabel: "Password",
    passwordLabelLowercase: "password",
    passwordConfirmationLabel: "Password Confirmation",
    passwordPlaceholder: "password",
    passwordInvalid: "Please enter a valid password",
    usernameOrPasswordInvalid: "The email or password entered is not recognised or not registered. Please check, try again or use forgotten password",
    forgotPassword: "Forgot Password?",
    yearTwoCharacters: "Year must be exactly 2 characters",
    cvvMinCharacters: "CVV must be at least 3 characters",
    addressLabel: "Address",
    address1Label: "Address 1",
    address1Placeholder: "address 1",
    address2Label: "Address 2",
    address2Placeholder: "address 2",
    cityLabel: "City",
    cityPlaceholder: "city",
    countyLabel: "County",
    countyPlaceholder: "county",
    postcodeLabel: "Postcode",
    postcodePlaceholder: "postcode",
    countryLabel: "Country",
    countryPlaceholder: "Country",
    phoneNumberLabel: "Phone Number",
    phoneNumberPlaceholder: "phone number",
    customerDetailsPhonePlaceholder: "phone number",
    phoneNumberInvalid: "Invalid Phone Number.",
    verificationCodeInvalid: "Invalid Verification Code",
    companyLabel: "Company",
    companyPlaceholder: "Company (optional)",
    genderLabel: "Gender",
    genderPlaceholder: "Select gender",
    genderSubtext: "For marketing research",
    editDetails: "Edit Details",
    nameOnCardLabel: "Name on Card",
    nameOnCardPlaceholder: "name on card",
    cardNumberLabel: "Card Number",
    cardNumberPlaceholder: "0000 0000 0000 0000",
    cardNumberInvalid: 'Credit Card number is invalid',
    cvvLabel: "CCV",
    cvvPlaceholder: "CCV",
    saveCardLabel: "Save Card Details",
    saveCardSubtext: "This will become the payment card for recurring purchases",
    removeCardTitle: "Remove card details",
    editPayment: "Edit Payment",
    isRequired: '{label} is required',
    required: 'Required',
    regionLabel: "Area Code",
    regionPlaceholder: "Select Your EXiS Number Region",
    helpPoint: "This area code will be used in your new EXiS number",
    dataObtain: "Find your CURP",
    validCurp: "Must be 18 alpha-numeric characters",
    uppercase: 'Must be uppercase characters only',
    promoCodeLabel: 'Promo Code',
    promoCodePlaceholder: 'Enter Promo Code',

  },
  storedPayment: {
    title: "Payment Method",
    selectPayment: 'Select Payment',
    storedCard: "Stored Card"
  },
  navigation: {
    dashboard: "Home",
    minutes: 'Minutes',
    data: 'Data',
    texts: 'Texts',
    topup: "Topup",
    addons: "Add-Ons",
    profile: "Account Details",
    giftSwap: "Community",
    bill: 'Profile',
    menu: "Menu",
    more: "Menu",
    payment: "Payment",
    paymentPortal: "Payment",
    checkout: "Checkout",
    confirmation: "Confirmation",
    receipt: "Update Receipt Number",
    logout: "Logout",
    home: "Home",
    about: "About",
    plans: "Plans",
    plansPortal: "Plans",
    alreadyHaveSim: "Already have a SIM?",
    port: "Switching",
    termsAndConditions: "Terms of Service",
    termsAndConditionsCaps: "TERMS AND CONDITIONS",
    dataProtectionCaps: "PRIVACY AND DATA PROTECTION",
    privacy: "Privacy policy",
    accessibility: "Accessibility",
    cookies: "Cookies policy",
    shipping: 'Shipping',
    support: 'Support',
    contact: 'Contact us',
    faq: 'FAQs',
    siteMap: "Site Map",
    lostFoundAndStolen: "Lost, Found and Stolen",
    loginAsAgent: "Login as Agent",
    customer: 'Customer',
    review: 'Review',
    backToShop: "Back to Shop",
    returnHome: "Return Home",
    seeHelp: "See help section",
    gift: 'Gift',
    swap: "Swap",
    helpAndFAQS: "Help and FAQs",
    switch: 'Port In',
    portOut: 'Port Out',
    identification: 'Edit Identification',
    address: 'Edit Address',
    coverage: "Coverage",
    compatible: "Compatible Devices",
    webAndApp: "WEB AND APP USE",
    viewBill: "View Bill",
    payBill: "Pay Bill",
    topUp: "Top Up",
    choosePlan: "Sign Up",
    hierarchy: "Hierarchy",
    customerSearch: "Customer Search",
    paymentHistory: "Payment History",
    manageSubscription: "Manage Subscription"
  },
  socialMedia: {
    facebook: 'Facebook',
    twitter: 'Twitter',
    instagram: 'Instagram',
    youtube: 'YouTube'
  },
  welcome: {
    title: "Welcome to Separate Reality Sign Up App",
    instructions: "Glad to have you aboard!\n Let’s get you started by signing in",
    action: "Get Started",
    footer: "Need Help?"
  },
  unavailable: {
    title: "Server Unavailable",
    instructions: "Oops, the server is not available right now, \ntry again later.",
    action: "Try again"
  },
  contactus: {
    header: "Contact",
    subheader: "Don't worry, we're \nhere to help",
    faqs: "The answer you are looking for may be",
    faqsSecondLine: 'in our ',
    faq: "Frequently Asked Questions.",
    support: "Customer Service and 24 hour support",
    telephoneNumber: "55 8996 0111",
    internetNumber: "55 8996 0060",
    number: "*11",
    telephone: "Mobile",
    internet: "Internet",
    exisNumber: "From your EXiS number",
    whatsapp: "Contact via WhatsApp",
    email: "Contact via Email",
  },
  login: {
    title: "Login",
    instructions: "Please enter your email address to login or register",
    actionLost: "Submit",
    action: "Sign in",
    actionUppercase: "Sign In",
    inProgress: "Logging in...",
    forgottenPassword: "Forgot password?",
    signUpLabel: "Don't have an account?",
    signUpLink: "  Signup",
    inProgressLost: "Submitting",
    validateToken: "Invalid Token",
    actionPort: "Switch",
    inProgressPort: "Switching",
    loginTitle: "Sign In as an Agent",
    contactManagement: "Contact Management"
  },
  registerHome: {
    title: "Ride Together",
    description: "Welcome to Biker Mobile.",
    description2: "Sign in or register below",
    newSIM: 'Already Have a SIM?',
    register: 'Register'
  },
  register_number: {
    title: "Register your Biker Mobile Number",
    instructions: "Please enter the phone number\n attached to the SIM card",
    note: "You will be sent a verification code",
    action: "Send",
    inProgress: "Sending...",
    validateErrorMessage: "Please enter a valid email address \nLower case and non-accented letters only",
    phoneNumberLabel: "Phone Number",
    phoneNumberPlaceholder: "phone number",
    phoneNumberPlaceholderTwo: "phone number",
    emailLabel: "Email",
    emailPlaceholder: "email",
    emailSubtext: "This will be your username",
    numberLength: 'Number must be 10 digits',
    numberDigits: 'Number must contain only numbers',
    validNumber: 'Invalid Number',
    iccidLabel: 'Last 5 digits of SIM Number (ICCID)',
    iccidPlaceholder: 'Enter Last 5 digits of SIM Number',
    emailDoesNotExist: "This email address is not associated with any Biker Mobile orders"
  },
  register_new_customer: {
    signup: 'Register your SIM',
    noEXiSNumber: 'Don\'t have an EXiS number?',
    getOneHere: 'Get one here',
    buttonTitle: 'Activate Account',
    giveUs5Minutes: 'Activating your account may take up to 5 minutes. If you don\'t see the updated data on the dashboard, give us a moment and reload the screen by pulling it down',
    registerEXiSNumber: "Si ya tienes un número EXiS,",
    register: "register",
    end: "para administrar tu cuenta",
    registerCaps: "Register",
    withSIM: "con tu SIM EXiS"
  },
  camera_components: {
    cancel_scanning: 'Cancel Scanning',
    loading_camera: 'Loading Camera',
    no_access: 'No access to camera'
  },
  verify_number: {
    title: "Verify Number",
    instructions: "You should receive an email\n with a verification code",
    action: "Verify",
    inProgress: "Verifying...",
    verificationCodeLabel: "Verification Code",
    verificationCodePlaceholder: "Enter Code",
    resendLabel: "Resend",
    cancel: "Cancel",
    resendMessageTemplate: "RESEND-AUTHCODE",
  },
  register_details: {
    title: "Registration Details",
    instructions: "Fill in your personal details",
    dob: "Date of Birth",
    action: 'Continue',
    firstName: "First Name",
    middleName: "Middle name",
    lastName: "Surname",
    postcode: "Postcode",
    day: "DD",
    month: "MM",
    year: "YYYY",
    genderLabel: "Gender",
    genderPlaceholder: "Select gender",
    genderSubtext: "For marketing research",
    cancel: "Cancel",
    noSpecialCharacters: 'Name must not contain any special characters',
    validPostcode: 'Postcode must contain 5 digits',
    invalidDay: 'Day is invalid',
    invalidMonth: 'Month must be between 1-12',
    invalidYear: 'Year You must be over 18 to purchase an account',
    invalidYear2: 'Age above 100 is not allowed',
    dayLength: 'Day should be 2 digits max',
    monthLength: 'Month should be 2 digits max',
    yearLength: 'Year should be 4 digits max',
    dayRequired: 'Day is required',
    monthRequired: 'Month is required',
    yearRequired: 'Year is required',
    male: 'Male',
    female: 'Female',
    preferNotToSay: 'Prefer not to say',
    marketingCommsConsent: 'I would like to receive marketing communications via:',
  },
  dashboard: {
    title: "Dashboard",
    instructions: "We have reached the dashboard! Yay!",
    action: "Sign Out",
    footer: "Need Help?",
    setup: 'Setup',
    setupDescription: 'Setup a recurring plan so you never run out of service.',
    texts: 'Texts',
    data: 'Data',
    minutes: 'Minutes',
    pendingPayment: 'Pending Payment',
    activatePrompt: 'Activate your subscription to begin using your service',
    activate: 'Activate',
    description: 'Description',
    cashPurchase: 'Cash Purchase',
    payUntil: 'Pay Until',
    buttonTitle: 'Show Barcode',
    button: 'Setup',
    planDescription: 'Setup a recuring plan so you never run out of service',
    gift: "GIFT",
    cancelDescription: "Are you sure you would like to cancel your recurring plan?",
    cancelSuccessful: "has been successfully cancelled",
    cancelFailed: "failed cancellation",
    exp: "Exp: ",
    payBill: 'Pay Bill',
    payMonthly: "Pay Monthly",
    viewBroadbandAddons: "View Addons",
    viewBill: "View Bill",
    payBill: "Pay Bill",
    amountDue: "Amount Due:",
    accountBalance: "Account Balance: ",
    payMonthly: "Pay Monthly"
  },
  activate_iccid: {
    title: "Activate SIM (ICCID)",
    action: "Activate",
    inProgress: "Activating...",
    iccidLabel: 'Last 5 digits of SIM Number (ICCID)',
    iccidPlaceholder: 'Enter Last 5 digits of SIM Number',
    emailLabel: "Email",
    emailPlaceholder: "email",
    emailSubtext: "This will be your username",
    numberLength: 'Number must be 10 digits',
    numberDigits: 'Number must contain only numbers',
    validNumber: 'Invalid Number',
    iccidLabel: 'Last 5 digits of SIM Number (ICCID)',
    iccidPlaceholder: 'Enter Last 5 digits of SIM Number',
    emailDoesNotExist: "This email address is not associated with any Biker Mobile orders"
  },
  balance: {
    loading_title: 'Loading',
    loading_legend: 'Waiting on server',
    postpaid_title: 'Estimated',
    postpaid_legend: 'For this Month',
    prepaid_title: 'Balance',
    prepaid_legend: 'Active Service',
    active: 'Active service',
    disabled: 'Service is disabled',
    unlimited: 'Unl.',
  },
  viewBill: {
    notAvailable: 'Your bill is not available at the moment. Please try again later or contact us for help.'
  },
  payBill: {
    fullAmount: "Full Amount",
    towardsYourBill: ' has been paid towards your bill.',
    selectAmount: 'Select Amount',
    congratulations: 'Congratulations!'
  },
  tariff: {
    title: 'Tariff',
    prepaid: 'Prepaid',
    postpoad: 'Monthly'
  },
  topup: {
    title: 'Topup',
    instructions: 'How much you want to top-up?',
    amount: "Amount"
  },
  addons: {
    title: 'Add-ons',
    instructions: 'Choose extra add ons',
    adtTitle: 'ADT Extras',
    adtDescription: 'Subscribe to ADT services',
    startingFrom: 'From',
    adtInstructions: 'Choose extra addons',
    searchCustomer: "Purchase Addon",
    purchaseAddons: "Purchase Addons"
  },
  profile: {
    title: 'Profile',
    instructions: 'Your profile preferences',
    accountLabel: 'Account Details',
    settingsLabel: 'Subscription Settings',
    switchLabel: 'Port In',
    manageSubscriptionLabel: 'Manage Subscription',
    changePlanLabel: 'Change Subscription',
    installEsimLabel: 'Install eSIM',
    portOutLabel: 'Port Out',
    cancelServiceLabel: 'Cancel Subscription',
  },
  cancel: {
    buttonLabel: 'Cancel Subscription',
    info: 'Selecting Cancel Subscription means that you do not wish to transfer your Biker Mobile number to a new service provider nor align the ceasing of the Biker Mobile Service with the start of mobile service from another provider. Once you have cancelled, this cannot be reversed and we will NOT be able to recover your Biker Mobile number. If you cancel within 14 days of the date of your ORDER, then we will process your 14 day money back guarantee refund in line with our terms and conditions. If you wish to proceed, click on \'Confirm Cancellation\' below',
    infoConfirmationIntro: 'Warning - After pressing "Confirm Cancellation" you will:',
    infoConfirmationPoint1: '\u2022 lose your Biker Mobile number',
    infoConfirmationPoint2: '\u2022 not be able to transfer your Biker Mobile number to a new service provider',
    infoConfirmationPoint3: '\u2022 not be able to align the ceasing of the Biker Mobile Service with the start of a mobile service from another provider',
    confirm: 'Confirm Cancellation',
    noPlan: 'You do not have an active plan to cancel or a payment subscription for this service',
    acknowledgeLabel: 'I understand and acknowledge the above details and wish to proceed with the cancellation of my service'
  },
  profile_summary: {
    description: 'Your Account Information',
    id: 'Identification',
    idDescription: 'Your details',
    idEdit: 'Edit details',
    address: 'Address',
    addressDescription: 'Your address',
    addressEdit: 'Edit address',
    payment: 'Payment',
    paymentDescription: 'Your recurring payment',
    paymentEdit: 'Edit payment',
    name: 'Name'
  },
  profile_identification: {
    description: 'Modify Your Name',
    noSpecialCharacters: 'Name must not contain special characters',
    rfcValid: 'RFC must be 12-13 alpha-numeric digits',
    title: 'Edit Identification'
  },
  profile_address: {
    description: 'Modify Your Address',
    noSpecialCharacters: 'Address must not contain special characters',
    validPostcode: 'Postcode must contain 5 digits',
    title: 'Edit Address',
    submit: 'Submit'
  },
  profile_payment: {
    updateSuccess: 'Congratulations! Your card ending in',
    updateSuccessTwo: "has been saved successfully.",
    updateFailed: 'Unfortunately updating your saved card has failed, please try again.',
    action: 'Back to Your Profile',
    noPayments: 'No payments found',
    paymentDate: 'Date',
    amount: 'Amount',
    status: 'Status',
    reference: 'Reference',
    type: 'Type'
  },
  service_settings: {
    description: 'Modify your service settings',
    title: 'Settings',
    numberNotValid: 'Number must be 10 digits',
    invalidPAC: 'Check you have entered a valid PAC code',
    invalidNumber: 'Number not valid',
    portInProduct: 'Port-In Product not Found',
    switch: 'Switch',
    pacInvalid: 'Number must be 4 digits'
  },
  manage_plan: {
    terms: 'Please be aware that plan changes need to be submitted 3 hours or more before your scheduled renewal date.\n\nPlan change requests 3 hours or less than your scheduled renewal date may not be implemented due to system processing times but we will do our best to process your request in time.'

  },
  switch_number: {
    description: 'Change your number to EXiS',
    numberNotValid: 'Number must be 11 digits and start with 07',
    invalidPAC: 'Check you have entered a valid PAC or STAC code',
    invalidNumber: 'Number not valid',
    portInProduct: 'Port-In Product not Found',
    switch: 'Switch',
    pacInvalid: 'Number must be 4 digits',
    portOutUnavailable: 'Sorry, it\'s not currently possible to request a PAC or STAC code via our app',
    portOutViaSMS: 'Text 65075 and your DOB (format dd/mm/yyyy) for a PAC code or 75075 and your DOB (format dd/mm/yyyy) for a STAC code',
    seeFAQs: 'For more information on different ways to obtain PAC or STAC Codes and switching networks please see our ',
    portOutFAQsLink: 'FAQs',
    portOutPACInstructions: 'We are sorry you are thinking of leaving Biker Mobile. \nIf you want to keep your current number then you\'ll need to request a PAC. We will send a PAC code to your current Biker Mobile number by SMS and you will receive an email with your subscription information.',
    portOutSTACInstructions: 'If you want to leave your current number behind when you leave Biker Mobile for another network, then you\'ll need to request a STAC. We will send the STAC code to your current Biker Mobile number by SMS and you will receive an email with subscription information.'
  },
  search: {
    action: "Search",
    inProgress: "Searching",
    customerSearch: "Customer Search",
    findYourCustomer: "Find your customer",
    searchPlaceholder: "search",
    numberNotValid: "Search must only contain numbers"
  },
  set_password: {
    title: "Create Password",
    instructions: "This password will be used for future\n access to your account",
    action: 'Continue',
    inProgress: "Submitting",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter Password",
    passwordConfirmLabel: "Re-enter Password",
    passwordConfirmPlaceholder: "Password",
    passwordsMatchError: "Passwords do not match",
    passwordRequirements: "8 Minimum characters \n1 Lowercase \n1 Uppercase \n1 Number",
    passwordRequirementsError: "password must contain: \n12 characters minimum \n1 Lowercase \n1 Uppercase \n1 Number \n1 Special Character"
  },
  forgotten_password: {
    title: "Forgotten Password",
    instructions: "Please enter your email address\n to reset your password",
    note: "You will be sent a verification code via SMS",
    action: "Send",
    inProgress: "Sending...",
    validateErrorMessage: "Please enter a valid email address \nLower case and non-accented letters only",
    emailLabel: "Email",
    emailPlaceholder: "email"
  },
  forgotten_password_auth: {
    title: "Verify",
    instructions: "You should receive a text message\n and email with a verification code",
    action: "Verify",
    inProgress: "Verifying...",
    verificationCodeLabel: "Verification Code",
    verificationCodePlaceholder: "Enter Verification Code",
    resendLabel: "Resend",
    resendLabelActive: "Resending...",
    cancel: "Cancel",
    resendMessageTemplate: "FORGOTTEN-PASSWORD"
  },
  forgotten_password_new_password: {
    title: "Reset Password",
    instructions: "This password will be used for future\n access to your account",
    action: 'Continue',
    actionInProgress: "Continuing",
    inProgress: "Submitting...",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter Password",
    passwordConfirmLabel: "Password Confirmation",
    passwordConfirmPlaceholder: "Password Confirmation",
    validateErrorMessage: "Passwords do not match"
  },
  bill_item: {
    title: "Billing",
    vat_included: "(Incl. VAT)",
    due_date: "Due date",
    over_due: "Over due",
    pay_bill: "Pay Bill"
  },
  pay_bill: {
    title: "Pay Bill",
    balance: "Bill Balance",
    loading: "Loading...",
    fullAmount: "Full Amount",
    partialAmount: "Partial Amount",
    fullAmountDescription: "Clear the bill's full balance and renew your data allowance.",
    partialAmountDescription: "Paying a partial amount might rollover the remaining balance to the next bill and incur late pay charges.",
    partialPaymentLabel: "Enter a different amount (£)",
    partialAmountPlaceholder: "Enter Amount",
    makingPayment: "Making Payment...",
    buttonApology: "Payment Not Available Yet",
    apologyError: "Cannot make payment yet, story VAD-58 is not complete, sorry :(",
    invalidAmount: "Cannot pay more than the ammount due",
    tooLow: "Cannot pay less that £1"
  },
  payment_method: {
    title: "Payment Method",
    instructions: "Please enter your payment details",
    storedPaymentInstructions: "Pay for the order using your stored card",
    creditCard: "Credit/Debit Card",
    creditCardInstructions: "Safe money transfer using your bank account. Visa, Maestro, Discover, American Express.",
    cash: "Cash",
    cashInstructions: "This will generate a barcode which can be sacnned at the nearest store.",
    applePay: "Apple Pay",
    applePayInstructions: "Select the card linked to your iCloud account.",
    googlePay: "Google Pay",
    googlePayInstructions: "Select the card linked to your Google account.",
    balance: "Balance",
    balanceInstructions: "Current balance is £220.00",
    bill: "Add to Bill",
    billInstructions: "Add the payment ammount to your next bill.",
    yearValid: 'Year must be valid',
    cvvValid: 'CVV must be valid',
    refundedPayment: "Make a payment of",
    refundedPaymentTwo: "that will be refunded so you can use these details for future payments.",
    saveCardDetails: "Save Card Details"
  },
  add_on_checkout: {
    title: 'Checkout',
    recurringTitle: 'Make it recurring',
    recurringText: "Set this product to recur so that you don't have to remember each month.",
    loading: "Loading...",
    submit: "Purchase",
    submitting: "Purchasing...",
    submitFailedButton: 'Purchasing Not Possible...',
    submitFailedFakeError: 'Purchasing not available until Steven gets the basket flow done!',
    cancel: 'Cancel'
  },
  payment_confirm: {
    done: "Done!",
    almostDone: "Almost done!",
    success: "Successfully Paid!",
    cashSuccess: "Successfully Ordered!",
    title: "Payment Confirmed!",
    action: "Home",
    topUp: "You have successfully topped up your balance by ",
    addOn1: "You have added: ",
    addOn2: " to your service.",
    payBill1: "You have now paid off ",
    payBill2: " your balance.",
    cash1: "Thanks for your purchase, your reference is: ",
    cashDescription: "Take your phone to your nearest participating store and scan the pending payment found on the Dashboard.",
    currencyCode: "GBP",
    saveAndReturn: "Home",
    adtInstruction: "Please login to the ADT website and proceed to follow the instructions"
  },
  paymentOptions: {
    title: "Payment Options",
    instructions: "Select what you would like to do: "
  },
  methods: {
    cash: "Cash",
    balance: "Prepaid Balance",
    bill: "Add To Invoice"
  },
  menu: {
    language: 'Language',
    whoMayUseThisService: 'Who May Use This Service',
    privacy: 'Privacy',
    contenTonService: 'Content on this Service',
    usingTheServices: 'Using the Services',
    disclaimer: 'Disclaimers and Limitations of Liability',
    general: 'General',
    voicemailStatus: "Processing",
    orderFailed: 'Order failed',
    gift: 'Gift',
    swap: 'Swap',
    giftLabel: 'Gift',
    swapLabel: 'Swap',
    transform: "Swap",
    termsAndConditions: 'Web and App Use',
    privacy: "Privacy and Data Protection",
    faqs: 'FAQs',
    preferences: 'Preferences',
    help: 'Help',
    giftSwapDescription: "Choose to gift or swap your balances.",
    activationFailed: 'Activation failed',
  },
  transfer: {
    transferFooter: 'Search the phone number',
    giftTo: 'Gift',
    giftAmount: 'Gift',
    send: 'Send',
    to: 'to',
    button: 'Gift'
  },
  home: {
    title: 'Sign Up',
    instructions: 'Welcome to the Sign Up application!',
    action: 'Choose your plan',
    firstPoint: "Download and install the app",
    secondTitle: "Contrata fácilmente.",
    button: "The process begins",
    subheader: "We are a company dedicated to keeping everyone connected in a simple and hassle-free way. We have 2 services, get to know them:",
    newsArticles: "News Articles"
  },
  about: {
    header: "EXiS is a \nhigh speed 4G \nmobile network.",
    subheader: "We focus on the service of you, a user who wants to control their \nplans from an app. Modify your data, minutes, and texts consumed and \nmake payments from the palm of your hands.",
    buttonText: "Choose your Plan",
    welcome: "Welcome to the Biker Mobile App for ",
    appVersion: "App version: ",
    copyright: "© Biker Mobile"
  },
  plans: {
    header: "Select the plan that best suits you",
    subheader: "No contracts, cancel anytime",
    single: "Single",
    recurring: "Recurring",
    singleMobile: "Single",
    singleWeb: "Single",
    recurringWeb: "Recurring",
    link: "Verify that your device is compatible",
    checkout: "Checkout our",
    termsAndConditions: "terms and conditions",
    forMoreDetails: "for more details"
  },
  plan: {
    header: "Plan Features",
    subheader: "Inclusive unlimited calls and texts",
  },
  planitem: {
    action: "Select",
    contract: "{validity} {validityUnit}{recurring}",
    day: "Day",
    days: "Days",
    week: "Week",
    weeks: "Weeks",
    month: "Month",
    months: "Months",
    year: "Year",
    years: "Years",
    autorenew: "Renews Automatically",
    allowsGiftSwap: "Allows gift/swap",
    minutes: "Minutes"
  },
  alreadyHaveSim: {
    header: "Activate your SIM",
    subheader: "Please enter the first 19 digits of the 20 character SIM serial number (Only numbers).",
    charactersRequired: "Please enter exactly 19 digits",
    validSIM: 'Please check you have entered the sim number correctly',
    checkSIM: 'Check you have entered a valid sim number',
    label: 'SIM Number',
    placeholder: 'SIM Number',
    getSIM: "Don't have a SIM? Get one here!",
    withoutLetter: "Only the 19 digits, without the letter",
    valid: "Please enter your SIM number"
  },
  port: {
    header: "Switch Your Number",
    subheader: "Always stay in control",
    thirdHeader: "Changing your line to EXiS is super simple, just fill out this form.",
    oldNumberLabel: "Telephone number",
    oldNumberPlaceholder: "mobile number (with current provider)",
    oldNumberLabelTwo: "Mobile Phone number (from your current provider)",
    pacCodeLabel: "PAC or STAC Code",
    pacCodePlaceholder: "PAC or STAC code",
    pacCodeFooter: "Provided by your previous network",
    confirmationTitle: "Switch in Progress",
    confirmationInstruction: "We’ve started your switching process, \nyou might experience temporarily disconnection while we switch\n your number, which can take up to 1 working day",
    enterDetails: "Enter your details",
    yourNames: "Your Names",
    names: "Forename",
    namesPlaceholder: "forename",
    middleName: "Middle Name",
    middleNamePlaceholder: "middle name",
    forename: "Paternal Last Name",
    surname: "Surname",
    fathersName: "Paternal Last Name",
    surnamePlaceholder: "surname",
    curp: "CURP",
    curpPlaceholder: "Unique Population Registry Code",
    curpFooter: "Don't know your CURP? We'll help you",
    stateLabel: "Where were you born?",
    stateFooter: "Select 'Ciudad de México' if you were born in D.F.",
    federalDistrict: "CIUDAD DE MÉXICO",
    curpButton: "Find my CURP",
    helpPoint: "Please obtain your PAC or STAC code from your previous Mobile Service provider. A PAC will enable you switch to Biker Mobile (whilst keeping your existing mobile number), whereas a STAC will enable you switch to Biker Mobile (without keeping your existing mobile number). Please refer to the Biker Mobile FAQs for further information.",
    noID: 'If you don\'t have or would rather use a different ID, call 55 8996 0111 so we can process the portability for you.',
    portDateLabel: "Preferred Switch Date",
    invalidDate: "Invalid Date",
    dateOutOfRange: "Date must be from tomorrow and within 30 days",
    setToTomorrow: "Set to tomorrow",
    orderFailed: 'The port in request has failed, please check your details and try again later. Alternatively contact customer services for help.',
  },
  lost: {
    header: "Lost, damaged or stolen",
    subheader: "Pause your service and get a replacement SIM",
    reasonLabel: 'Reason',
    reasonPlaceholder: 'Select your reason',
    reasonLost: 'Lost',
    reasonStolen: 'Stolen',
    reasonDamaged: 'Damaged',
    reasonOther: 'Other',
    confirmationTitle: "Suspended account",
    confirmationInstruction: "Everything will be fine. \nYour service has been temporarily canceled, \na new SIM will be sent to you. \nOnce you activate it, your account will resume."
  },
  help: {
    title: "We're here to help",
    header: "FAQs",
    subheader: "Browser our most frequent questions and answers",
    learnAboutUs: "Learn more about us",
    learnAboutUsDescription: "Here at Biker Mobile, we believe that staying connected and safe when you're out on a ride should be effortless.",
    contactCallCenterTitle: "Contact Customer Service",
    contactWhatsAppTitle: "Contact Us Via WhatsApp",
    visitWebsite: "Visit our website",
    chat: "Chat with us",
  },
  legal: {
    header: "Legal",
    headerCaps: "LEGAL",
    subheader: "Browser our legal terms and conditions",
    termsOfService: "Terms of service",
    privacyPolicy: "Privacy policy",
    visitOurWebsite: "Visit our website"
  },
  discounts: {
    discountCodeAppliedMessage: (discountName) => `Promotion applied - ${discountName || ''}`,
    discountCodeAppliedAddOnsMessage: (discountName) => `Your code has been accepted. The discount ${discountName || ''} will be applied to the price shown above when your payment is taken on the next screen`,
  },
  checkout: {
    header: "Checkout",
    customerInformation: "Customer Information",
    paymentMethod: "Payment Method",
    review: "Review",
    processing: "Processing",
    summary: "Summary",
    cartIsEmpty: "Your cart is empty",
    emptyCart: "Empty Cart",
    discount: "Discount",
    shipping: "Shipping",
    free: "Free",
    tax: "Tax",
    subtotal: "Subtotal",
    total: "Total",
    purchase: "Purchase",
    orderProcessing: "Processing your order...",
    orderProcessingFailed: "Your order failed.",
    orderPendingShippingNoSim: "Your order is on the way!",
    orderPendingShippingWithSim: "Thanks for your purchase!",
    orderProcessedShortly: "Your order will be processed shortly",
    orderPendingShippingInfoNoSim: 'Your SIM has been ordered, \nyou will recieve an email once it has been dispatched. \nOnce it is paired you will be able to setup your account,\nin the mean time you can download the app here.',
    orderPendingShippingInfoWithSim: 'You will recieve a confirmation email. \nOnce it is paired you will be able to setup your account, \nin the mean time you can download the app here',
    orderPendingPairing: "Your order will be handled soon!",
    orderPendingPairingInfo: 'Your SIM should be paired soon, \nonce it is paired you will be able to setup your account, \nin the mean time you can download the app.',
    receiptWanted: "Do you need a Receipt?",
    changeRFC: "Change RFC",
    noRFC: "No RFC Number",
    total: "Total",
    numberDigits: 'Number must only contain digits',
    numberLength: 'Number must be 10 digits',
    referalCode: "Please enter discount code",
    saveCardEnglish: "Save card details for number ending in ",
    areYouSure: "Are You Sure?",
    areYouSureLong: "Are you sure you want to save the \ncard ending in ",
    yourNewNumberIs: "Your new number is",
    preview: "Add a saved card for future purchases",
    validDevice: "My device is compatible",
    checkHere: "(Check here)",
    paymentPollingFailed: "Payment was not successful within the permitted time. Please try again.",
    imeiRequired: "Must be a valid device",
    termsAndConditionsRequired: "Terms and conditions must be read",
    privacyPolicyRequired: "Privacy policy must be read",
    mustBeSelected: "Must be selected",
    readAndAccept: "I have read and accept",
    readAndAcceptTwo: "I have read and accept",
    termsFull: "Terms and Conditions of Service",
    privacyFull: "Privacy Policy",
    loading: "Loading",
    saveCardDetails: 'Save Card Details',
    saveCardDetailInstructions: 'Save your card detils so they can be used in the future. This is required for recurring payments.',
    emptyBasket: "Basket is empty.",
    basket: "Basket",
    viewDetails: "View Details"
  },
  notes: {
    title: "Notes",
    addNote: "Add Note",
    noNotes: "No notes"
  },
  update_receipt_number: {
    title: 'Update Your RFC Code',
    label: "RFC Code",
    validateRFC: 'RFC code must not contain any special characters',
    failed: 'Failed'
  },
  agent: {
    navbarTitle: "Acting as Agent",
    header: "Agent Portal",
    subheader: "This sign in page is only for sales agents, \nenter your credentials",
    contactManagement: "Contact Management",
    multipleAccounts: 'multiple accounts with this number exist',
    referralCode: "Referral code",
    invalidReferralCode: "Invalid referral code"
  },
  product: {
    plan: 'Plan',
    renewDate: 'Renew Date',
    expiryDate: 'Expires On',
    price: 'Price',
    switch: 'Switch',
    makeRecurring: 'Make Recurring',
    expiryShort: 'Exp',
    per: '/',
    months: 'months',
    days: 'days',
    weeks: 'weeks',
    years: 'years',
  },
  gift: {
    confirm: 'Gifted',
    validnumber: 'Number must contain 10 digits',
    numberNotValid: 'Number not valid',
    send: 'Send',
    to: 'to',
    notFoundBalanceTransfer: 'not found balance transfer product',
    ofYourOwn: 'of your own allowance have been sent to',
    asGift: 'as gift allowance',
    transferAllowances: 'Transfer your allowances',
    giftInstructions: "Share data, minutes or sms of your plan with others. Enter the phone number you want to send a gift",
    noCredits: "You don´t have enough applicable credits for this gift "
  },
  swap: {
    confirm: 'Swapped',
    description: 'Modify your plan',
    secondDescription: 'Change data, minutes and SMS',
    submit: 'Transform',
    texts: 'Texts',
    data: 'Data',
    minutes: 'Minutes',
    textsDisplayUnits: 'Textos',
    minutesDisplayUnits: 'Minutos',
    noApplicableBalances: 'No applicable balances',
    notFoundBalance: 'Not found balance transform product',
    incorrectBalanceInput: 'Balance not inputted correctly',
    from: 'From',
    to: 'To',
    transform: 'Transform',
    into: 'into',
    minimum: 'Minimum',
    maximum: 'Maximum',
    swapped: 'Swapped',
    ofYourOwn: 'of your own allowance have been swapped into',
    textsSuffix: "Text(s)",
    minutesSuffix: "Minute(s)",
    dataSuffix: "of Data"
  },
  customer_details: {
    title: "Customer Details",
    scan: "Scan ID"
  },
  scan_barcode: {
    title: 'Scan Barcode',
    description: 'Click the button to scan the barcode, or manually input the barcode below',
    enter_barcode: 'Enter Barcode'
  },
  scan_id: {
    scan: 'Scan',
    back: 'Back to Details'
  },
  select_plan: {
    title: 'Select Plan',
    description: 'Select the plan from below that the customer wants',
    prepaid_plans: 'Prepaid Plans',
    postpaid_plans: 'Postpaid Plans',
    plans_loading: 'Plans loading'
  },
  take_picture: {
    title: 'Customer Image',
    description: 'Click the button to take a picture of the customer, the image will be displayed below',
    info: 'The image will display below',
    take_picture: 'Take Picture'
  },
  nca_summary: {
    summary: "Summary",
    description: "You're just one step away from signing up to the customer, confirm all the details, take payment and then press Submit",
    details: "Details",
    plan: "Plan: ",
    name: "Name: ",
    phoneNum: "Phone Number: ",
    idNum: "ID Number: "
  },
  customer_summary: {
    username: "Username",
    role: "Role",
    identity: "Identity",
    born: "Born",
    gender: "Gender",
    language: "Language",
    id: "ID",
    address: "Address",
    addressIntro: "The account holder address:",
    line2: "Line 2",
    state: "State",
    zipCode: "Zip code",
    city: "City",
    country: "Country",
    editAddress: "Edit Address",
    accountsServicesSubscriptions: "Accounts/Services/Subscriptions"
  },
  customer_dashboard: {
    noAccounts: 'No accounts returned',
    tryAgain: 'Try Again',
    noMatches: 'No accounts match the filter',
    clear: 'Clear Filter'
  },
  account_dashboard: {
    noServices: 'No services returned',
    tryAgain: 'Try Again',
    noMatches: 'No services match the filter',
    clear: 'Clear Filter',
    accountId: "Account ID",
    accountType: "Account Type",
    status: "Status",
    services: "Services",
    serviceId: "Service ID",
    type: "Type",
    mode: "Mode",
    tenure: "Tenure",
    lineNumber: "Line Number",
    created: "Created"
  },
  customerDashboard: {
    title: "Customer Dashboard",
    filter: "filter",
    accountId: "Account ID",
    accountType: "Account Type",
    tenure: "Tenure",
    created: "Created",
    alias: "Alias"
  },
  accountDashboard: {
    title: "Account Dashboard"
  },
  serviceDashboard: {
    title: "Service Dashboard",
    serviceId: "Service ID",
    service: "Service",
    billing: "Billing",
    status: "Status",
    plan: "Plan",
    balance: "Balance",
    buyAddons: "Buy Addons",
    topUp: "Top Up",
    disconnect: "Disconnect",
    subscription: "Subscription",
    buyPPVs: "Buy PPVs",
    manageSubscriptions: "Manage Subscriptions",
    bill: "Bill",
    payBill: "Pay Bill",
    purchaseHistory: "Purchase History",
    name: "Name",
    price: "Price",
    date: "Date",
    noPlan: "No Plan",
    data: "Data",
    minutes: "Minutes",
    texts: "Texts",
    purchaseId: "Purchase ID",
    name: "Name",
    price: "Price",
    date: "Date"
  },
  errors: {
    unknown: "An error occurred, please try again and contact customer support if the issue persists",
    timeoutReached: "The server encountered a temporary error and could not complete your request. Please try again later",
    SMSCountExceeded: "Maximum number of requests exceeded\n Please contact customer services",
    userLocked: "User Locked\nPlease contact customer services",
    agentLocked: "Agent Locked",
    notAllowed: "You are not allowed to access this page",
    failedPurchase: "Purchase Failed",
    invalidEmailAddress: "This email address does not belong to a registered user",
    alreadyRegistered: "This user is already registered, Please sign in with your registered e-mail address and password",
    networkUnavailable: "You're offline. Please make sure you're online and try again",
    customerLoginAsAgent: "You must be an agent to login",
    validDOB: "Please enter a valid date of birth",
    pendingOrders: "Customer has pending orders",
    emailNotExist: "This email doesn't exist",
    serviceDisconnected: "Service Disconnected. Please contact call centre",
    customerNotFound: "Customer does not exist",
    statusInvalid: "Status invalid",
    paymentFailed: "Payment Failed",
    mustUpdate: "Please update your app to the latest version in the App Store",
    orderFailed: "Order Failed",
    invalidSimLength: "The ICCID is an invalid length",
    simInUse: "The ICCID is already in use",
    usernameOrPasswordInvalid: "The email or password entered is not recognised or not registered. Please check, try again or use forgotten password",

    authenticationError: "Authentication failed. Please try again.",
    decodingError: "Authentication token could not be processed",
    tokenExpired: "Your session has expired. Please sign in again",
    tokenInvalid: "Invalid session token",
    accessControl: "You are not authorised to perform this action",
    securityCheckInvalid: "Security check failed",

    accountLocked: "Account Locked\nPlease contact customer services",
    userInvalid: "Invalid user details",
    accountInvalid: "Invalid account",
    noAccountExists: "No account exists for this user",
    registrationIncomplete: "Registration is incomplete. Please finish setup",
    mustChangePassword: "You must change your password before continuing",

    networkUnreachable: "Network unreachable. Please try again later",
    connectionTimeout: "Connection timed out. Please try again",
    persistence: "A system error occurred while saving data",
    dataError: "Invalid or corrupted data received",
    microserviceError: "A backend service is currently unavailable",

    basketInvalid: "Basket is invalid",
    basketEmpty: "Your basket is empty",
    paymentUnsuccessful: "Payment was unsuccessful. Please try another method",
    insufficientBalance: "Insufficient balance to complete this transaction",
    refundUnsuccessful: "Refund could not be processed",

    serviceInvalid: "Invalid service configuration",
    productNotFound: "Product not found",
    planNotSupported: "Selected plan is not supported",

    oneTimePasscodeInvalid: "Invalid verification code",
    authCodeExpired: "Verification code has expired. Please request a new one",
    invalidIccidScan: "Invalid ICCID, please try entering or scanning again and if the problem persists contact customer support",
    simInUse: "This SIM cannot be registered",
    promoCodeErrors: {
      PROMO_NOT_AVAILABLE: "Invalid code",
      PROMO_MAX_REDEMPTIONS_REACHED: "This code has reached its maximum number of redemptions",
      COUPON_MAX_REDEMPTIONS_REACHED: "The related coupon has reached the maximum number of redemptions",
      PROMO_MINIMUM_AMOUNT_NOT_MET: "This code has a minimum order value, which has not been met",
      COUPON_PRODUCT_RESTRICTION: "This code is not valid for the selected product",
      PROMO_CUSTOMER_RESTRICTION: "You are not authorised to use this code",
      PROMO_MINIMUM_AMOUNT_CURRENCY_MISMATCH: "This code cannot be used for purchases in the selected currency",
      PROMO_EXPIRED: "This code has expired",
      PROMO_NOT_ACTIVE: "This code is no longer active",
      COUPON_NOT_FOUND: "Invalid code (Coupon Not Found)",
      COUPON_NOT_ACTIVE: "Invalid code (Coupon Not Active)",
      COUPON_EXPIRED: "Invalid code (Coupon Expired)",
      COUPON_NOT_VALID: "Invalid code (Coupon Not Valid)",
      EMAIL_ADDRESS_REQUIRED: "Missing email address",
      TARGET_PRODUCT_NOT_FOUND: "Invalid code (Product Not Found)",
      PROMO_COUPON_MISSING: "Invalid code (Promo Coupon Missing)"
    }
  },
  signUp: {
    description: 'Click below to begin the sign up process'
  },
  community: {
    title: "Biker Mobile Community",
    vision: "Our vision is to help bikers find and share great people and places - cafes, B&Bs, mechanics and shops - where they're truly welcome.",
    movement: "We're more than just a mobile service - we're building a movement.",
    reinvest: "With every SIM sold, we reinvest into biker events, support projects and biker-owned businesses that share our values.",
    comingSoon: "Further updates are coming soon... including the total contributions made by Biker Mobile to the biker community."
  },
  errorMapping: {
    ADAPTOR_ERROR: {
      registration: "errors.invalidIccidScan"
    },
    ESIM_ALREADY_LINKED: {
      registration: "errors.simInUse"
    },
    SR0001: {
      authcode: "forms.verificationCodeInvalid",
      registration: "forms.verificationCodeInvalid",
      login: "forms.usernameOrPasswordInvalid",
      agentLogin: "forms.usernameOrPasswordInvalid",
      forgottenPassword: "forms.verificationCodeInvalid",
      invalidEmailAddress: "errors.emailNotExist"
    },
    SR0002: {
      login: "errors.userLocked",
      forgottenPassword: "errors.userLocked",
      agentLogin: "errors.agentLocked"
    },
    SR0004: {
      login: "errors.userLocked",
      agentLogin: "errors.agentLocked"
    },
    SR0005: {
      login: "errors.notAllowed",
      agentLogin: "errors.notAllowed"
    },
    SR0009: {
      forgottenPassword: "Unauthorized"
    },
    SR0014: {
      registration: "forms.phoneNumberInvalid",
      login: "errors.unknown",
      checkout: "errors.failedPurchase",
      forgottenPassword: "errors.unknown",
      profileAddress: "errors.unknown"
    },
    SR0017: {
      registration: "errors.alreadyRegistered"
    },
    SR0020: {
      forgottenPassword: "errors.invalidEmailAddress"
    },
    SR0022: {
      forgottenPassword: "forms.phoneNumberInvalid",
      registration: "forms.phoneNumberInvalid",
    },
    SR0041: {
      registration: "errors.statusInvalid"
    },
    SR0042: {
      forgottenPassword: "errors.SMSCountExceeded",
      registration: "errors.SMSCountExceeded"
    },
    SR0043: {
      agentLogin: "errors.mustUpdate",
      login: "errors.mustUpdate",
      registration: "errors.mustUpdate",
      forgottenPassword: "errors.mustUpdate"
    },
    SR0101: {
      lost: "errors.pendingOrders",
      gift: "errors.pendingOrders",
      checkout: "errors.pendingOrders"
    },
    SR9999: {
      agentLogin: "errors.timeoutReached",
      login: "errors.timeoutReached",
      registration: "errors.timeoutReached"
    },
    SR00172: {
      login: "errors.customerNotFound",
      search: "errors.customerNotFound",
      agentLogin: "errors.customerNotFound"
    },
    NO_USER_EXISTS: {
      login: "errors.usernameOrPasswordInvalid",
      forgottenPassword: "errors.emailNotExist",
    },
    1000: "errors.orderFailed",
    1002: "errors.alreadyRegistered",
    1003: "errors.invalidSimLength",
    1004: "errors.simInUse",
    CREDENTIALS_INVALID: {
      login: "errors.usernameOrPasswordInvalid",
    },
    USER_LOCKED: {
      login: "errors.userLocked",
      forgottenPassword: "errors.userLocked",
      agentLogin: "errors.agentLocked"
    },
    ALREADY_REGISTERED: {
      registration: "errors.alreadyRegistered"
    },
    MAX_NUMBER_OF_AUTHCODE_SMS_SENDS: {
      forgottenPassword: "errors.SMSCountExceeded",
      registration: "errors.SMSCountExceeded"
    },
    ORDERS_PENDING: {
      lost: "errors.pendingOrders",
      gift: "errors.pendingOrders",
      checkout: "errors.pendingOrders"
    },
    ACCOUNT_LOCKED: {
      login: "errors.userLocked",
      forgottenPassword: "errors.userLocked",
      agentLogin: "errors.agentLocked"
    },
    CUSTOMER_INVALID: {
      registration: "errors.customerNotFound"
    },
    AUTHENTICATION_ERROR: {
      login: "errors.authenticationError"
    },
    DECODING_ERROR: {
      login: "errors.decodingError"
    },
    TOKEN_EXPIRED: {
      login: "errors.tokenExpired"
    },
    TOKEN_INVALID: {
      login: "errors.tokenInvalid"
    },
    ACCESS_CONTROL: {
      login: "errors.notAllowed"
    },
    SECURITY_CHECK_INVALID: {
      login: "errors.securityCheckInvalid"
    },
    USER_INVALID: {
      login: "errors.userInvalid"
    },
    ACCOUNT_INVALID: {
      login: "errors.accountInvalid"
    },
    NO_ACCOUNT_EXISTS: {
      login: "errors.noAccountExists"
    },
    REGISTRATION_INCOMPLETE: {
      registration: "errors.registrationIncomplete"
    },
    MUST_CHANGE_PASSOWRD: {
      login: "errors.mustChangePassword"
    },
    NETWORK_UNREACHABLE: {
      login: "errors.networkUnreachable"
    },
    CONNECTION_TIMEOUT: {
      login: "errors.timeoutReached"
    },
    BASKET_INVALID: {
      checkout: "errors.basketInvalid"
    },
    BASKET_EMPTY: {
      checkout: "errors.basketEmpty"
    },
    PAYMENT_UNSUCCESSFUL: {
      checkout: "errors.paymentUnsuccessful"
    },
    INSUFFICIENT_BALANCE: {
      checkout: "errors.insufficientBalance",
      gift: "errors.insufficientBalance"
    },
    REFUND_UNSUCCESSFUL: {
      profilePayment: "errors.refundUnsuccessful"
    },
    SERVICE_INVALID: {
      dashboard: "errors.serviceInvalid"
    },
    PRODUCT_NOT_FOUND: {
      dashboard: "errors.productNotFound"
    },
    SERVICEPLAN_NOT_SUPPORTED: {
      checkout: "errors.planNotSupported"
    },
    ONE_TIME_PASSCODE_INVALID: {
      login: "errors.oneTimePasscodeInvalid",
      registration: "errors.oneTimePasscodeInvalid",
      forgottenPassword: "errors.oneTimePasscodeInvalid"
    },
    AUTH_CODE_EXPIRED: {
      login: "errors.authCodeExpired",
      forgottenPassword: "errors.authCodeExpired"
    },
    HIBERNATE_PERSISTENCE_ERROR: {
      checkout: "errors.persistence"
    },
    DATA_ERROR: {
      checkout: "errors.dataError"
    },
    ACCOUNT_MICROSERVICE_ERROR: {
      login: "errors.microserviceError"
    },
    PAYMENT_MICROSERVICE_ERROR: {
      checkout: "errors.microserviceError"
    },
    ORDER_MICROSERVICE_ERROR: {
      checkout: "errors.microserviceError"
    },
  }
}


